module.exports = require("prismjs/components/prism-markup.js");